export default __webpack_public_path__ + "static/media/7.15b30295.jpg";